module.exports = __webpack_public_path__ + "static/media/s_sf_5.b9a31cdc.png";